import { Platform, StyleSheet } from 'react-native';

export default StyleSheet.create({
  pageBannerContainerStyle: {
    ...Platform.select({
      ios: {
        marginTop: 23,
      },
      android: {
        marginTop: 13,
        marginBottom: 7,
      },
    }),
  },
  pageBannerTitleStyle: {
    lineHeight: 22.9,
  },
  updatingContainer: {
    marginTop: 12.33,
    marginEnd: -8,
  },
  manualRefreshContainerStyle: {
    marginTop: 3.5,
    marginEnd: -7,
  },
});
